var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloseButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 18,
    fill: "#EFF0EF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.9998 11.9998C23.8123 11.8123 23.558 11.707 23.2928 11.707C23.0277 11.707 22.7733 11.8123 22.5858 11.9998L17.9998 16.5858L13.4138 11.9998C13.2263 11.8123 12.972 11.707 12.7068 11.707C12.4417 11.707 12.1873 11.8123 11.9998 11.9998C11.8123 12.1873 11.707 12.4417 11.707 12.7068C11.707 12.972 11.8123 13.2263 11.9998 13.4138L16.5858 17.9998L11.9998 22.5858C11.8123 22.7733 11.707 23.0277 11.707 23.2928C11.707 23.558 11.8123 23.8123 11.9998 23.9998C12.1873 24.1873 12.4417 24.2926 12.7068 24.2926C12.972 24.2926 13.2263 24.1873 13.4138 23.9998L17.9998 19.4138L22.5858 23.9998C22.7733 24.1873 23.0277 24.2926 23.2928 24.2926C23.558 24.2926 23.8123 24.1873 23.9998 23.9998C24.1873 23.8123 24.2926 23.558 24.2926 23.2928C24.2926 23.0277 24.1873 22.7733 23.9998 22.5858L19.4138 17.9998L23.9998 13.4138C24.1873 13.2263 24.2926 12.972 24.2926 12.7068C24.2926 12.4417 24.1873 12.1873 23.9998 11.9998Z",
    fill: "#011602"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseButton);
export default __webpack_public_path__ + "static/media/closeButton.dcf1dbaf3c15f453eb123609fa09c1bc.svg";
export { ForwardRef as ReactComponent };